import axios from 'axios'
import { useNexusStore } from '../stores/nexusStore'

const NEXUS_BASE = import.meta.env.VITE_API_BASE
  ? `${import.meta.env.VITE_API_BASE}/nexus/api`
  : '/nexus/api'

const nexusApi = axios.create({
  baseURL: NEXUS_BASE,
  headers: { 'Content-Type': 'application/json' },
})

nexusApi.interceptors.request.use((config) => {
  const token = useNexusStore.getState().token
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

nexusApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      useNexusStore.getState().logout()
      window.location.href = '/nexus/login'
    }
    return Promise.reject(error)
  }
)

export default nexusApi
